import { render, staticRenderFns } from "./bar-chart-widget.vue?vue&type=template&id=632420fe"
import script from "./bar-chart-widget.vue?vue&type=script&lang=js"
export * from "./bar-chart-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632420fe')) {
      api.createRecord('632420fe', component.options)
    } else {
      api.reload('632420fe', component.options)
    }
    module.hot.accept("./bar-chart-widget.vue?vue&type=template&id=632420fe", function () {
      api.rerender('632420fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/bar-chart-widget.vue"
export default component.exports